import React, { Dispatch } from 'react'

import './Header.scss'
import HeaderResults from './HeaderResults'
import { connect } from 'react-redux'
import { IReduxAction } from '../../utils/ReduxStore'

import SettingsButton from './Settings/SettingsButton'
import ShowResultsButton from './ShowResultsButton'
import NewTabLink from '../Helpers/NewTabLink'

interface IDispatchProps {
  reset: () => void
}

interface IProps extends IDispatchProps {}

class Header extends React.Component<IProps> {
  public render(): JSX.Element {
    return (
      <div id="Header" className="Header row d-flex align-items-center">
        <div className="Title col-12 col-md-6 mt-2 mt-md-0">
          <div className="d-flex align-items-center">
            <h1 className="mb-0">Canadian Election Explorer 2019</h1>
            <button
              className="About btn btn-dark ml-2 mr-2"
              data-toggle="modal"
              data-target="#AboutModal"
            >
              <i className="fas fa-lg fa-info-circle" />
              <span className="d-none d-sm-inline ml-2">About</span>
            </button>
          </div>
          <div className="row By">
            <div className="col Legend mb-1 mb-sm-2 mb-md-3">
              <small>
                By{' '}
                <NewTabLink href="https://plotandscatter.com">
                  Plot + Scatter
                </NewTabLink>
                . Last updated October 22<sup>nd</sup>, 2019.
              </small>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <SettingsButton />
              <ShowResultsButton />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 mt-2 mt-md-0">
          <HeaderResults />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  reset: (): void => {
    dispatch({ type: 'RESET' })
  }
})

export default connect(
  undefined,
  mapDispatchToProps
)(Header)
